export const PAGE_SIZE = 10;

const NAMES = {
  USDT_TRC20: "USDT TRC20",
  USDT_ERC20: "USDT ERC20",
  USDT_BEP20: "USDT BEP20",
  BANK: "Bank",
  TRC20: "TRC20",
  ERC20: "ERC20",
  BEP20: "BEP20",
  super_admin: "Super admin",
  daily_earning: "Daily earning",
  direct_commission: "Direct commission",
  level_commission: "Level commission",
  transfer_in: "Transfer in",
  transfer_out: "Transfer out",
  withdrawal_refund: "Withdrawal refund",
  admin_credit: "Admin credit",
  admin_debit: "Admin debit",
  INCLUDED_IN_SCHEDULE: "Included in schedule",
};

export function label(value) {
  if (value === null || value === undefined || value === "") return "—";
  if (NAMES[value]) return NAMES[value];
  const text = String(value).split("_").join(" ");
  return text.charAt(0).toUpperCase() + text.slice(1);
}

export function money(value) {
  const amount = Number(value);
  if (!Number.isFinite(amount)) return "0.00";
  return amount.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

export function percent(value) {
  const amount = Number(value);
  if (!Number.isFinite(amount)) return "—";
  return amount.toLocaleString("en-US", { maximumFractionDigits: 2 }) + "%";
}

export function when(value) {
  if (!value) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "—";
  return date.toLocaleString(undefined, {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function text(value) {
  if (value === null || value === undefined || value === "") return "—";
  return value;
}

export function qs(params) {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "") return;
    search.set(key, String(value));
  });
  const query = search.toString();
  return query ? "?" + query : "";
}

export function setQuery(current, setParams, updates) {
  const next = new URLSearchParams(current);
  Object.entries(updates).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "") next.delete(key);
    else next.set(key, String(value));
  });
  setParams(next);
}
